<template>
    <div>
        <div class="left_box">
            <ul>
                <li @click="into('msgType', 0)"
                    v-if="config.menuInfo && config.menuInfo.typeStatistic.messageType"
                    :class="{'check_current': domIndex == 0}"> 留言类型统计</li>
                <li @click="into('ser', 1)"
                    v-if="config.menuInfo && config.menuInfo.typeStatistic.serviceCenterType"
                    :class="{'check_current': domIndex == 1}">服务中心统计</li>
                <li @click="into('msgWhere', 2)"
                    v-if="config.menuInfo && config.menuInfo.typeStatistic.messageFromType"
                    :class="{'check_current': domIndex == 2}">留言来源统计</li>
                <li @click="into('msgType', 0)">返回顶部</li>
            </ul>
        </div>
        <div class="right_box">
            <div v-if="config.menuInfo && config.menuInfo.typeStatistic.messageType"
                 class="page_box"
                 name="msgType"
                 id="msgType">
                <div class="box_top">
                    <span class="box_title">留言类型统计</span>
                    <span class="box_tab"
                          :class="{'tsj': msgTypeIndex == -1}"
                          @click="changeMsgType('year', -1)">本年</span>
                    <span class="box_tab"
                          :class="{'tsj': msgTypeIndex == 0}"
                          @click="changeMsgType('month', 0)">本月</span>
                    <span class="box_tab"
                          :class="{'tsj': msgTypeIndex == 1}"
                          @click="changeMsgType('week', 1)">本周</span>
                    <span class="box_tab"
                          :class="{'tsj': msgTypeIndex == 2}"
                          @click="changeMsgType('day', 2)">昨天</span>
                    <span class="box_tab"
                          :class="{'tsj': msgTypeIndex == 3}"
                          @click="changeMsgType('', 3)">

                        <a-range-picker v-model="time1"
                                        @change="changeTime1">
                            <div style="font-size: 16px;"
                                 v-if="msgTypeIndex == 3"
                                 :class="{'search_item_current': msgTypeIndex == 3}">
                                {{ msgTypeIndex == 3 && time1 ?   moment(time1[0]).format("YYYY-MM-DD") + ' ~ ' + moment(time1[1]).format("YYYY-MM-DD") : '开始日期 ~ 结束日期'}}
                            </div>
                            <div style="font-size: 16px;"
                                 v-else>
                                请选择
                            </div>
                        </a-range-picker>
                    </span>
                </div>
                <div class="box_content">
                    <div class="list_content">
                        <div>
                            <a-row class="list_border list_title">
                                <a-col :span="6">
                                    <div class="list_data flex_nowrap">留言类型</div>
                                </a-col>
                                <a-col :span="6">
                                    <div class="list_data flex_nowrap">留言数</div>
                                </a-col>
                                <a-col :span="6">
                                    <div class="list_data flex_nowrap">回复数</div>
                                </a-col>
                                <a-col :span="6">
                                    <div class="list_data flex_nowrap">平均回复时间（小时）</div>
                                </a-col>

                            </a-row>
                        </div>
                        <div>
                            <a-row class="list_title"
                                   v-if="msgTypeList.length == 0">
                                <a-col :span="24">
                                    <div class="list_data flex_nowrap">暂无数据</div>
                                </a-col>
                            </a-row>
                        </div>
                        <div>
                            <a-row v-for="item in msgTypeList">
                                <a-col :span="6">
                                    <div class="list_data flex_nowrap">{{item.messageTypeName}}</div>
                                </a-col>
                                <a-col :span="6">
                                    <div class="list_data flex_nowrap">{{item.messageNum || 0}}</div>
                                </a-col>
                                <a-col :span="6">
                                    <div class="list_data flex_nowrap">{{item.replyNum || 0}}</div>
                                </a-col>
                                <a-col :span="6">
                                    <div class="list_data flex_nowrap">{{item.replyNum ? (item.waitTime / item.replyNum).toFixed(2) : 0}}</div>
                                </a-col>
                            </a-row>
                        </div>
                        <div>
                            <a-row class="list_heji">
                                <a-col :span="6">
                                    <div class="list_data flex_nowrap">合计</div>
                                </a-col>
                                <a-col :span="6">
                                    <div class="list_data flex_nowrap">{{msgAll.allMsg}}</div>
                                </a-col>
                                <a-col :span="6">
                                    <div class="list_data flex_nowrap">{{msgAll.allReply}}</div>
                                </a-col>
                                <a-col :span="6">
                                    <div class="list_data flex_nowrap">{{msgAll.allReply ? (msgAll.allWaitTime / msgAll.allReply).toFixed(2) : 0}}</div>
                                </a-col>

                            </a-row>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="config.menuInfo && config.menuInfo.typeStatistic.serviceCenterType"
                 class="page_box"
                 name="ser"
                 id="ser">
                <div class="box_top">
                    <span class="box_title">服务中心统计</span>
                    <span class="box_tab"
                          :class="{'tsj': serIndex == -1}"
                          @click="changeSer('year', -1)">本年</span>
                    <span class="box_tab"
                          :class="{'tsj': serIndex == 0}"
                          @click="changeSer('month', 0)">本月</span>
                    <span class="box_tab"
                          :class="{'tsj': serIndex == 1}"
                          @click="changeSer('week', 1)">本周</span>
                    <span class="box_tab"
                          :class="{'tsj': serIndex == 2}"
                          @click="changeSer('day', 2)">昨天</span>
                    <span class="box_tab"
                          :class="{'tsj': serIndex == 3}"
                          @click="changeSer('', 3)">

                        <a-range-picker v-model="time2"
                                        @change="changeTime2">
                            <div style="font-size: 16px;"
                                 v-if="serIndex == 3"
                                 :class="{'search_item_current': serIndex == 3}">
                                {{ serIndex == 3 && time2 ?   moment(time2[0]).format("YYYY-MM-DD") + ' ~ ' + moment(time2[1]).format("YYYY-MM-DD") : '开始日期 ~ 结束日期'}}
                            </div>
                            <div style="font-size: 16px;"
                                 v-else>
                                请选择
                            </div>
                        </a-range-picker>
                    </span>
                </div>
                <div class="box_content">
                    <div class="list_content">
                        <div>
                            <a-row class="list_border list_title">
                                <a-col :span="5">
                                    <div class="tl list_data flex_nowrap">校区</div>
                                </a-col>
                                <a-col :span="7">
                                    <div class="tl list_data flex_nowrap">服务中心</div>
                                </a-col>
                                <a-col :span="3">
                                    <div class="list_data flex_nowrap">留言数</div>
                                </a-col>
                                <a-col :span="3">
                                    <div class="list_data flex_nowrap">回复数</div>
                                </a-col>
                                <a-col :span="6">
                                    <div class="list_data flex_nowrap">平均回复时间（小时）</div>
                                </a-col>
                            </a-row>
                        </div>
                        <div>
                            <a-row class="list_title"
                                   v-if="serList.length == 0">
                                <a-col :span="24">
                                    <div class="list_data flex_nowrap">暂无数据</div>
                                </a-col>
                            </a-row>
                        </div>
                        <div>
                            <a-row v-for="item in serList">
                                <a-col :span="5">
                                    <div class="tl list_data flex_nowrap">{{item.schoolCampusName}}</div>
                                </a-col>
                                <a-col :span="7">
                                    <div class="tl list_data flex_nowrap">{{item.serviceCentreName}}</div>
                                </a-col>
                                <a-col :span="3">
                                    <div class="list_data flex_nowrap">{{item.messageNum || 0}}</div>
                                </a-col>
                                <a-col :span="3">
                                    <div class="list_data flex_nowrap">{{item.replyNum || 0}}</div>
                                </a-col>
                                <a-col :span="6">
                                    <div class="list_data flex_nowrap">{{item.replyNum ? (item.waitTime / item.replyNum).toFixed(2) : 0}}</div>
                                </a-col>
                            </a-row>
                        </div>
                        <div>
                            <a-row class="list_heji">
                                <a-col :span="5">
                                    <div class="tl list_data flex_nowrap">合计</div>
                                </a-col>
                                <a-col :span="7">
                                    <div class="tl list_data flex_nowrap"></div>
                                </a-col>
                                <a-col :span="3">
                                    <div class="list_data flex_nowrap">{{serAll.allMsg}}</div>
                                </a-col>
                                <a-col :span="3">
                                    <div class="list_data flex_nowrap">{{serAll.allReply}}</div>
                                </a-col>
                                <a-col :span="6">
                                    <div class="list_data flex_nowrap">{{serAll.allReply ? (serAll.allWaitTime / serAll.allReply).toFixed(2) : 0}}</div>
                                </a-col>
                            </a-row>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="config.menuInfo && config.menuInfo.typeStatistic.messageFromType"
                 class="page_box"
                 name="msgWhere"
                 id="msgWhere">
                <div class="box_top">
                    <span class="box_title">留言来源统计</span>
                    <span class="box_tab"
                          :class="{'tsj': sourceIndex == -1}"
                          @click="changeSource('year', -1)">本年</span>
                    <span class="box_tab"
                          :class="{'tsj': sourceIndex == 0}"
                          @click="changeSource('month', 0)">本月</span>
                    <span class="box_tab"
                          :class="{'tsj': sourceIndex == 1}"
                          @click="changeSource('week', 1)">本周</span>
                    <span class="box_tab"
                          :class="{'tsj': sourceIndex == 2}"
                          @click="changeSource('day', 2)">昨天</span>
                    <span class="box_tab"
                          :class="{'tsj': sourceIndex == 3}"
                          @click="changeSource('', 3)">

                        <a-range-picker v-model="time3"
                                        @change="changeTime3">
                            <div style="font-size: 16px;"
                                 v-if="sourceIndex == 3"
                                 :class="{'search_item_current': sourceIndex == 3}">
                                {{ sourceIndex == 3 && time3 ?   moment(time3[0]).format("YYYY-MM-DD") + ' ~ ' + moment(time3[1]).format("YYYY-MM-DD") : '开始日期 ~ 结束日期'}}
                            </div>
                            <div style="font-size: 16px;"
                                 v-else>
                                请选择
                            </div>
                        </a-range-picker>
                    </span>
                </div>
                <div class="box_content last_content">
                    <div class="list_content">
                        <div>
                            <a-row class="list_border list_title">
                                <a-col :span="6">
                                    <div class="list_data flex_nowrap">留言来源</div>
                                </a-col>
                                <a-col :span="6">
                                    <div class="list_data flex_nowrap">留言数</div>
                                </a-col>
                                <a-col :span="6">
                                    <div class="list_data flex_nowrap">回复数</div>
                                </a-col>
                                <a-col :span="6">
                                    <div class="list_data flex_nowrap">平均回复时间（小时）</div>
                                </a-col>

                            </a-row>
                        </div>
                        <div>
                            <a-row class="list_title"
                                   v-if="sourceList.length == 0">
                                <a-col :span="24">
                                    <div class="list_data flex_nowrap">暂无数据</div>
                                </a-col>
                            </a-row>
                        </div>
                        <div>
                            <a-row v-for="item in sourceList">
                                <a-col :span="6">
                                    <div class="list_data flex_nowrap">{{item.dataSource | dataSource}}</div>
                                </a-col>
                                <a-col :span="6">
                                    <div class="list_data flex_nowrap">{{item.messageNum || 0}}</div>
                                </a-col>
                                <a-col :span="6">
                                    <div class="list_data flex_nowrap">{{item.replyNum || 0}}</div>
                                </a-col>
                                <a-col :span="6">
                                    <div class="list_data flex_nowrap">{{item.replyNum ? (item.waitTime / item.replyNum).toFixed(2) : 0}}</div>
                                </a-col>
                            </a-row>
                        </div>
                        <div>
                            <a-row class="list_heji">
                                <a-col :span="6">
                                    <div class="list_data flex_nowrap">合计</div>
                                </a-col>
                                <a-col :span="6">
                                    <div class="list_data flex_nowrap">{{sourceAll.allMsg}}</div>
                                </a-col>
                                <a-col :span="6">
                                    <div class="list_data flex_nowrap">{{sourceAll.allReply}}</div>
                                </a-col>
                                <a-col :span="6">
                                    <div class="list_data flex_nowrap">{{sourceAll.allReply ? (sourceAll.allWaitTime / sourceAll.allReply).toFixed(2) : 0}}</div>
                                </a-col>
                            </a-row>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import getTme from "../common/time";
import { mapGetters } from "vuex";
import moment from "moment";
export default {
    data() {
        return {
            moment,
            time1: undefined,
            time2: undefined,
            time3: undefined,
            msgTypeIndex: -1,
            msgTypeList: [],
            msgAll: {
                allMsg: 0,
                allReply: 0,
                allWaitTime: 0
            },
            serIndex: -1,
            serList: [],
            serAll: {
                allMsg: 0,
                allReply: 0,
                allWaitTime: 0
            },
            sourceIndex: -1,
            sourceList: [],
            sourceAll: {
                allMsg: 0,
                allReply: 0,
                allWaitTime: 0
            },
            domIndex: 0
        };
    },
    computed: {
        ...mapGetters(["config"])
    },
    created() {
        this.changeMsgType("year", -1);
        this.changeSer("year", -1);
        this.changeSource("year", -1);
    },
    methods: {
        into(dom, index) {
            this.domIndex = index;
            document.getElementById(dom).scrollIntoView();
        },
        changeMsgType(time, index) {
            if (getTme[time] && getTme[time]()) {
                this.time1 = undefined;
                this.msgTypeIndex = index;
                this.$api
                    .getMsgTypeStatistic({
                        startTime: getTme[time]()[0],
                        endTime: getTme[time]()[1]
                    })
                    .then(res => {
                        this.msgAll = {
                            allMsg: 0,
                            allReply: 0,
                            allWaitTime: 0
                        };
                        res.param.list.forEach(item => {
                            this.msgAll.allMsg += item.messageNum;
                            this.msgAll.allReply += item.replyNum;
                            this.msgAll.allWaitTime += item.waitTime;
                        });
                        this.msgTypeList = res.param.list;
                    });
            } else {
                this.msgTypeIndex = index;
                this.msgTypeList = [];
            }
        },
        changeTime1() {
            this.$api
                .getMsgTypeStatistic({
                    startTime:
                        moment(this.time1[0]).format("YYYY-MM-DD") +
                        " 00:00:00",
                    endTime:
                        moment(this.time1[1]).format("YYYY-MM-DD") + " 23:59:59"
                })
                .then(res => {
                    this.msgAll = {
                        allMsg: 0,
                        allReply: 0,
                        allWaitTime: 0
                    };
                    res.param.list.forEach(item => {
                        this.msgAll.allMsg += item.messageNum;
                        this.msgAll.allReply += item.replyNum;
                        this.msgAll.allWaitTime += item.waitTime;
                    });
                    this.msgTypeList = res.param.list;
                });
        },
        changeSer(time, index) {
            if (getTme[time] && getTme[time]()) {
                this.serIndex = index;
                this.time2 = undefined;
                this.$api
                    .getSerStatistic({
                        startTime: getTme[time]()[0],
                        endTime: getTme[time]()[1]
                    })
                    .then(res => {
                        this.serAll = {
                            allMsg: 0,
                            allReply: 0,
                            allWaitTime: 0
                        };
                        res.param.list.forEach(item => {
                            this.serAll.allMsg += item.messageNum;
                            this.serAll.allReply += item.replyNum;
                            this.serAll.allWaitTime += item.waitTime;
                        });
                        this.serList = res.param.list;
                    });
            } else {
                this.serIndex = index;
                this.serList = [];
            }
        },
        changeTime2() {
            this.$api
                .getSerStatistic({
                    startTime:
                        moment(this.time2[0]).format("YYYY-MM-DD") +
                        " 00:00:00",
                    endTime:
                        moment(this.time2[1]).format("YYYY-MM-DD") + " 23:59:59"
                })
                .then(res => {
                    this.serAll = {
                        allMsg: 0,
                        allReply: 0,
                        allWaitTime: 0
                    };
                    res.param.list.forEach(item => {
                        this.serAll.allMsg += item.messageNum;
                        this.serAll.allReply += item.replyNum;
                        this.serAll.allWaitTime += item.waitTime;
                    });
                    this.serList = res.param.list;
                });
        },
        changeSource(time, index) {
            if (getTme[time] && getTme[time]()) {
                this.sourceIndex = index;
                this.time3 = undefined;
                this.$api
                    .getSourceStatistic({
                        startTime: getTme[time]()[0],
                        endTime: getTme[time]()[1]
                    })
                    .then(res => {
                        this.sourceAll = {
                            allMsg: 0,
                            allReply: 0,
                            allWaitTime: 0
                        };
                        res.param.list.forEach(item => {
                            this.sourceAll.allMsg += item.messageNum;
                            this.sourceAll.allReply += item.replyNum;
                            this.sourceAll.allWaitTime += item.waitTime;
                        });
                        this.sourceList = res.param.list;
                    });
            } else {
                this.sourceIndex = index;
                this.sourceList = [];
            }
        },
        changeTime3() {
            this.$api
                .getSourceStatistic({
                    startTime:
                        moment(this.time3[0]).format("YYYY-MM-DD") +
                        " 00:00:00",
                    endTime:
                        moment(this.time3[1]).format("YYYY-MM-DD") + " 23:59:59"
                })
                .then(res => {
                    this.sourceAll = {
                        allMsg: 0,
                        allReply: 0,
                        allWaitTime: 0
                    };
                    res.param.list.forEach(item => {
                        this.sourceAll.allMsg += item.messageNum;
                        this.sourceAll.allReply += item.replyNum;
                        this.sourceAll.allWaitTime += item.waitTime;
                    });
                    this.sourceList = res.param.list;
                });
        }
    },
    filters: {
        dataSource(val) {
            if (val == 0) {
                return "移动端留言";
            } else {
                return "网页端留言";
            }
        }
    }
};
</script>
<style lang="scss" scope>
.left_box {
    width: 160px;
    height: 170px;
    position: fixed;
    top: 290px;
    box-shadow: #b4b4b4 0 0 5px;
    ul {
        width: 100%;
        height: 100%;
    }
    li {
        margin: 0 10px;
        width: 140px;
        height: 42.5px;
        line-height: 42.5px;
        text-align: center;
        padding-left: 12px;
        border-bottom: 1px solid #c8c8c8;
        cursor: pointer;
    }
    li:nth-child(3) {
        border: 0;
    }
    li:last-child {
        width: 160px;
        padding: 0;
        margin: 0;
        border: 0;
        text-align: center;
        background: url("../../assets/top.png") no-repeat 32px center;
        background-color: #d8eaff;
    }

    .check_current {
        color: #3686e3;
        background: url("../../assets/rsj.png") no-repeat 12px center;
    }
}
.right_box {
    width: 900px;
    margin-left: 180px;
    height: calc(100vh - 341px);
    overflow: auto;
}
</style>